(function () {
  var modal = document.querySelector('[data-company-invoice-modal]');

  if (!modal || modal.dataset.companyInvoiceReady === 'true') return;

  modal.dataset.companyInvoiceReady = 'true';

  var form = modal.querySelector('[data-company-invoice-form]');
  var dialog = modal.querySelector('[data-company-invoice-dialog]');
  var saveButton = modal.querySelector('[data-company-invoice-save]');
  var saveLabel = modal.querySelector('[data-company-invoice-save-label]');
  var formStatus = modal.querySelector('[data-company-invoice-form-status]');
  var fields = Array.prototype.slice.call(modal.querySelectorAll('[data-company-invoice-field]'));
  var originalParent = modal.parentNode;
  var i18n = {
    save: modal.dataset.i18nSave || 'Save',
    saving: modal.dataset.i18nSaving || 'Saving...',
    errorRequired: modal.dataset.i18nErrorRequired || 'This field is required.',
    errorEmail: modal.dataset.i18nErrorEmail || 'Enter a valid email address.',
    errorSave: modal.dataset.i18nErrorSave || 'Invoice details could not be saved. Please try again.'
  };
  var lastTrigger = null;
  var currentAttributes = {};
  var mutationFrame = null;

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root + path;
  }

  function normalizeAttributes(attributes) {
    return attributes && typeof attributes === 'object' ? attributes : {};
  }

  function invoiceIsSaved() {
    return currentAttributes['Invoice Requested'] === 'Yes';
  }

  // Remembered per browser: a shopper who does not need an invoice should not have
  // to dismiss the card again on every page or every visit.
  var DISMISS_KEY = 'bcCompanyInvoiceDismissed';

  function invoiceIsDismissed() {
    try {
      return window.localStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setInvoiceDismissed(value) {
    try {
      if (value) window.localStorage.setItem(DISMISS_KEY, '1');
      else window.localStorage.removeItem(DISMISS_KEY);
    } catch (e) {}
  }

  function renderEntries() {
    var saved = invoiceIsSaved();
    var dismissed = !saved && invoiceIsDismissed();

    document.querySelectorAll('[data-company-invoice-entry]').forEach(function (entry) {
      var wrap = entry.querySelector('[data-company-invoice-banner-wrap]');
      var trigger = entry.querySelector('[data-company-invoice-trigger]');
      var reopen = entry.querySelector('[data-company-invoice-reopen]');
      var status = entry.querySelector('[data-company-invoice-status]');

      if (wrap) wrap.hidden = saved || dismissed;
      else if (trigger) trigger.hidden = saved || dismissed;
      if (reopen) reopen.hidden = saved || !dismissed;
      if (status) status.hidden = !saved;
    });
  }

  function readCart() {
    return fetch(cartUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart details.');
      return response.json();
    }).then(function (cart) {
      currentAttributes = normalizeAttributes(cart.attributes);
      renderEntries();
      return currentAttributes;
    });
  }

  function clearFieldError(field) {
    var wrapper = field.closest('.company-invoice-field');
    var error = wrapper ? wrapper.querySelector('[data-company-invoice-error]') : null;

    field.removeAttribute('aria-invalid');
    if (error) error.textContent = '';
  }

  function setFieldError(field, message) {
    var wrapper = field.closest('.company-invoice-field');
    var error = wrapper ? wrapper.querySelector('[data-company-invoice-error]') : null;

    field.setAttribute('aria-invalid', 'true');
    if (error) error.textContent = message;
  }

  function clearErrors() {
    fields.forEach(clearFieldError);
    formStatus.hidden = true;
    formStatus.textContent = '';
  }

  function populateFields() {
    fields.forEach(function (field) {
      field.value = currentAttributes[field.dataset.companyInvoiceField] || '';
    });
  }

  function focusableElements() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function openModal(trigger) {
    lastTrigger = trigger || document.activeElement;
    clearErrors();

    readCart().catch(function () {
      return currentAttributes;
    }).then(function () {
      var cartContext = trigger
        ? trigger.closest('.quick-cart, .cart')
        : null;

      (cartContext || originalParent).appendChild(modal);
      populateFields();
      modal.hidden = false;
      document.body.classList.add('company-invoice-modal-open');

      window.requestAnimationFrame(function () {
        var firstField = modal.querySelector('[data-company-invoice-field]');
        if (firstField) firstField.focus();
      });
    });
  }

  function closeModal() {
    if (modal.hidden) return;

    modal.hidden = true;
    document.body.classList.remove('company-invoice-modal-open');
    clearErrors();
    originalParent.appendChild(modal);

    if (lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus();
    }
  }

  function validate() {
    var firstInvalid = null;

    clearErrors();

    fields.forEach(function (field) {
      var value = field.value.trim();

      if (field.hasAttribute('data-company-invoice-required') && !value) {
        setFieldError(field, i18n.errorRequired);
        if (!firstInvalid) firstInvalid = field;
        return;
      }

      if (field.type === 'email' && value && !field.checkValidity()) {
        setFieldError(field, i18n.errorEmail);
        if (!firstInvalid) firstInvalid = field;
      }
    });

    if (firstInvalid) {
      firstInvalid.focus();
      return false;
    }

    return true;
  }

  function collectAttributes() {
    var attributes = {
      'Invoice Requested': 'Yes',
      'Invoice Type': 'Company Invoice'
    };

    fields.forEach(function (field) {
      attributes[field.dataset.companyInvoiceField] = field.value.trim();
    });

    return attributes;
  }

  function setSaving(saving) {
    saveButton.disabled = saving;
    saveLabel.textContent = saving ? i18n.saving : i18n.save;
  }

  function saveInvoice(event) {
    event.preventDefault();

    if (!validate()) return;

    setSaving(true);

    fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: collectAttributes() })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to save invoice details.');
      return response.json();
    }).then(function (cart) {
      currentAttributes = normalizeAttributes(cart.attributes);
      renderEntries();
      closeModal();
    }).catch(function () {
      formStatus.textContent = i18n.errorSave;
      formStatus.hidden = false;
    }).finally(function () {
      setSaving(false);
    });
  }

  function handleDocumentClick(event) {
    var dismiss = event.target.closest('[data-company-invoice-dismiss]');
    if (dismiss) {
      event.preventDefault();
      event.stopPropagation();
      setInvoiceDismissed(true);
      renderEntries();
      return;
    }

    var reopen = event.target.closest('[data-company-invoice-reopen]');
    if (reopen) {
      event.preventDefault();
      setInvoiceDismissed(false);
      renderEntries();
      openModal(reopen);
      return;
    }

    var trigger = event.target.closest('[data-company-invoice-trigger], [data-company-invoice-edit]');
    var close = event.target.closest('[data-company-invoice-close]');

    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (close && modal.contains(close)) {
      event.preventDefault();
      closeModal();
    }
  }

  function handleModalKeydown(event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = focusableElements();
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  fields.forEach(function (field) {
    field.addEventListener('input', function () {
      clearFieldError(field);
    });
  });

  form.addEventListener('submit', saveInvoice);
  document.addEventListener('click', handleDocumentClick);
  modal.addEventListener('keydown', handleModalKeydown);
  document.addEventListener('cart:updated', readCart);
  document.addEventListener('shopify:section:load', readCart);

  new MutationObserver(function () {
    if (mutationFrame) window.cancelAnimationFrame(mutationFrame);
    mutationFrame = window.requestAnimationFrame(renderEntries);
  }).observe(document.body, { childList: true, subtree: true });

  readCart().catch(function () {
    renderEntries();
  });
})();
